import * as types from "../actions/actionTypes";
import getUserIdentification from "../assets/getUserIdentification";
const initialState = {
  loading: false,
  data: null,
  error: "",
  processing: false,
  changePasswordProcessing: false
};

const User = (state = initialState, action) => {
  let previousData = {},
    fullName = "";
  switch (action.type) {
    case types.GET_USER_INFO_REQUEST:
      return { ...state, loading: true, data: null, error: "" };
    case types.GET_USER_INFO_SUCCESS:
      previousData = state.data ? { ...state.data } : {};
      fullName = getUserIdentification(action.data);
      return {
        ...state,
        loading: false,
        data: { ...previousData, ...action.data, fullName: fullName }
      };
    case types.GET_USER_INFO_FAILURE:
      return { ...state, loading: false, error: action.error };

    case types.UPDATE_USER_INFO_REQUEST:
      return { ...state, processing: true };
    case types.UPDATE_USER_INFO_SUCCESS:
      previousData = state.data ? { ...state.data } : {};
      fullName = getUserIdentification(action.data);
      return {
        ...state,
        processing: false,
        data: { ...previousData, ...action.data, fullName: fullName }
      };
    case types.UPDATE_USER_INFO_FAILURE:
      return { ...state, processing: false };

    case types.CHANGE_PASSWORD_REQUEST:
      return { ...state, changePasswordProcessing: true };
    case types.CHANGE_PASSWORD_SUCCESS:
      return { ...state, changePasswordProcessing: false };
    case types.CHANGE_PASSWORD_FAILURE:
      return { ...state, changePasswordProcessing: false };

    default:
      return state;
  }
};

export default User;
